import { trackAdjustEvent as trackAdjustEventHelper } from '@inkitt/web-privacy';
import { trackClientError } from '../tracking/trackClientError';

export const ADJUST_EVENT_TOKEN_MAP = {
  View_Content: 'x30wc2',
};
export type AdjustEventName = keyof typeof ADJUST_EVENT_TOKEN_MAP;

export const trackAdjustEvent = (
  eventToken: AdjustEventName,
  eventData?: { [key: string]: number | string | boolean },
) => {
  const mappedEventToken = ADJUST_EVENT_TOKEN_MAP[eventToken as AdjustEventName];
  if (!mappedEventToken) {
    trackClientError({
      name: 'AdjustServiceTrackEventError',
      error: new Error(`Can't find event token for ${eventToken}`),
    });
    return;
  }

  trackAdjustEventHelper({ ...eventData, eventToken: mappedEventToken });
};
